// Seeded PRNG (mulberry32) so a given seed always produces the same
// sequence of spawns/weather — needed for reproducible saves and debugging.

export interface RngState {
  seed: number;
}

export function createRng(seed: number): RngState {
  return { seed: seed >>> 0 };
}

export function nextRandom(rng: RngState): number {
  rng.seed = (rng.seed + 0x6d2b79f5) >>> 0;
  let t = rng.seed;
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
}

export function randomInt(rng: RngState, minInclusive: number, maxExclusive: number): number {
  return minInclusive + Math.floor(nextRandom(rng) * (maxExclusive - minInclusive));
}

/** Uniform float in [min, max] — for continuous ranges (e.g. a spawned
 * node's nominal capacity), as opposed to randomInt's integer bucket. */
export function randomInRange(rng: RngState, min: number, max: number): number {
  if (max <= min) return min;
  return min + nextRandom(rng) * (max - min);
}

export function randomChoice<T>(rng: RngState, items: readonly T[]): T {
  return items[randomInt(rng, 0, items.length)];
}
